import {
  CountrySetting,
  SettingCountryListRequest,
  SettingCountryListResponse,
} from './types'
import { fx } from '../../../../libs'
import { createEvent, restore, sample } from 'effector'
import {
  getPromoCodeList,
  promoCodeListMounted,
} from '../../promoCodes/list/model'

export const SettingCountryListMounted =
  createEvent<SettingCountryListRequest>()

export const getSettingCountryList = fx<
  SettingCountryListRequest,
  SettingCountryListResponse
>({
  method: 'GET',
  url: `/deposit_bonus/unavailable_country`,
})

export const $settingCountryList = restore<CountrySetting[]>(
  getSettingCountryList.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfSettingCountryList = restore(
  getSettingCountryList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: SettingCountryListMounted,
  fn: ({ orderBy, orderDirection }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {}

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    return {
      query,
    }
  },
  target: getSettingCountryList,
})
